<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    float: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, float } = context.props
    const vnodes = []
    if (icon && !float) {
      vnodes.push(<svg-icon icon-class={icon} />)
    }

    if (title && !float) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }

    if (icon && float) {
      vnodes.push(<span><span slot='title'>{(title)}</span><svg-icon icon-class={icon} class-name='rightIcon' /></span>)
    }

    return vnodes
  }
}
</script>

<style lang="scss">
.rightIcon {
  margin-left: 10px;
  width: 18px !important;
  height: 18px !important;
}
</style>
